module.exports = __webpack_public_path__ + "img/tpc-15.affb5fee.webp";